import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import newPersonActivity from './modules/newPersonActivity'

Vue.use(Vuex)

const _store = new Vuex.Store({
    modules: {
        app,
        user,
        newPersonActivity,
    },
})

export default _store
